<template>
  <div
    :key="`${id}__catalog`"
    class="multi-section-wrap"
  >
    <CatalogList
      v-if="hasCatalogList"
      :id="id"
      :key="id"
      :catalog-list="catalogList"
    />
    <div class="min-h-screen" v-else></div>
  </div>
</template>
<script setup>
import { computed, defineProps } from 'vue'
import CatalogList from '@/components/catalog/CatalogList.vue'

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  catalog: {
    type: Object,
    default: null
  }
})

const catalogList = computed(() => props.catalog?.catalogList)
const hasCatalogList = computed(
  () => catalogList.value && catalogList.value?.length > 0
)
</script>
<style lang="scss">
.min-h-screen {
  min-height: 100vh;
}
</style>
